import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueApexCharts from "vue3-apexcharts";
import money from 'v-money3'
import {Tabs, Tab} from 'vue3-tabs-component';
import 'tabulator-tables/dist/css/tabulator_simple.min.css'
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import * as Sentry from "@sentry/vue";
import 'vue3-toastify/dist/index.css';
import '@/css/main.css'
import './echartLocales'
import { registerDirectives } from './directives'
const app = createApp(App).component('tabs', Tabs).component('tab', Tab)

Sentry.init({
  app,
  dsn: "https://2fa9a8b779434cac05c4ac26c17c102b@o4509413664882688.ingest.us.sentry.io/4509413674647552",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: import.meta.env.VITE_SENTRY_NODE_ENV,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "https://api.atlasfin.com.br", "https://assets.atlasfin.com.br"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  
  // Bloqueia envio de eventos em desenvolvimento
  beforeSend(event) {
    // Se estiver em desenvolvimento, não envia eventos
    if (import.meta.env.VITE_SENTRY_NODE_ENV === 'development') {
      console.log('Evento Sentry bloqueado (desenvolvimento):', event);
      return null;
    }
    return event;
  }
});

app.config.performance = true;
app.use(router)
app.use(VueApexCharts)
app.use(money)
registerDirectives(app)
app.use(Vue3Toastify, {
    autoClose: 2000,
    clearOnUrlChange: false,
    position: 'bottom-right',
  } as ToastContainerOptions);
app.mount('#app')

